import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './mobile/styles.scss'
import './styles.scss'

import AILogo from '../../../assets/ai-logo.svg'
import CloseButton from '../../../assets/close.svg'
import ExpandIcon from '../../../assets/expand.svg'
import Expand from '../../elements/expand'

import { useVehicleContext } from '../../../hooks/useVehicleContext'

function Launcher({ expanded, setExpanded, children }) {
  const { t } = useTranslation()
  const [touchStartY, setTouchStartY] = useState(null)
  const [touchEndY, setTouchEndY] = useState(null)
  const { vehicleType } = useVehicleContext()

  const vehicleName = vehicleType
    ? vehicleType
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : ''
  console.log(vehicleType, vehicleName)

  const handleTouchStart = (event) => {
    setTouchStartY(event.touches[0].clientY)
  }

  const handleTouchMove = (event) => {
    setTouchEndY(event.touches[0].clientY)
  }

  const handleTouchEnd = () => {
    if (touchStartY && touchEndY) {
      const swipeDistance = touchStartY - touchEndY

      if (swipeDistance > 50) {
        setExpanded(true) // Expand on swipe up
      }
    }
    setTouchStartY(null)
    setTouchEndY(null)
  }

  const handKeyDownEnter = (event) => {
    if (event.key === 'Enter') {
      setExpanded(!expanded)
    }
  }

  return (
    <div
      className={'chat-wrapper-launcher'}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {/*<div>*/}
      <div
        className="chat-wrapper-launcher-mobile-trigger"
        onClick={() => setExpanded(!expanded)}
      />
      <div
        className={'chat-wrapper-launcher__content'}
        tabIndex="1"
      >
        <img
          src={AILogo}
          alt="Toggle AI assistant"
          onClick={() => setExpanded(!expanded)}
          tabIndex="1"
          onKeyDown={handKeyDownEnter}
        />
        {/*{!expanded && !hasHistory && (*/}
        {/*  <Suggestions*/}
        {/*    suggestions={suggestions}*/}
        {/*    className="chat-wrapper__suggestions"*/}
        {/*    inline*/}
        {/*    onClick={(text) => onSuggestionClick(text)}*/}
        {/*  />*/}
        {/*)}*/}

        <p className="chat-wrapper-launcher__continue">
          {t(`${vehicleType}.launcher.introduction`)}
        </p>

        {expanded && (
          <img
            src={CloseButton}
            className="btn btn-close"
            alt="Close AI assistant"
            onClick={() => setExpanded(false)}
            tabIndex="1"
            onKeyDown={handKeyDownEnter}
          />
        )}
        {!expanded && (
          <Expand
            onClick={() => setExpanded(!expanded)}
            className="chat-wrapper__expands chat-wrapper__expand-btn"
          >
            <img
              src={ExpandIcon}
              alt="Toggle AI assistant"
            />{' '}
            {t('launcher.expand')}
          </Expand>
        )}
      </div>
      {/*</div>*/}

      {/*<LauncherMobile expanded={expanded} setExpanded={setExpanded} suggestions={suggestions}/>*/}
      {/*<LauncherDesktop expanded={expanded} setExpanded={setExpanded}/>*/}
      <div className={'chat-wrapper-launcher__suggestions'}>{children}</div>
    </div>
  )
}

export default Launcher
